document.addEventListener("DOMContentLoaded", () => {
  // 1) SELECTORES compatibles con Minimog y Dawn
  const containerSel = [
    // Minimog (según variante)
    ".m-announcement-bar .m-slider",        // p.ej. wrapper del slider
    ".m-topbar .m-slider",
    "[data-announcement-slider]",
    // Dawn (fallback)
    ".announcement-bar-slider .m-a-slider", // Isolated custom
    ".announcement-bar-slider .slider"
  ].join(",");

  const slideSel = [
    ".m-announcement-bar .m-slider .m-slide", // Minimog
    ".m-topbar .m-slider .m-slide",
    ".m-a-slide",                             // Isolated custom
    ".slider__slide"                          // Dawn
  ].join(",");

  const prevBtnSel = [
    ".m-announcement-bar .m-slider__prev",    // Minimog
    ".m-topbar .m-slider__prev",
    ".slider-button--prev"                    // Dawn
  ].join(",");

  const nextBtnSel = [
    ".m-announcement-bar .m-slider__next",    // Minimog
    ".m-topbar .m-slider__next",
    ".slider-button--next"                    // Dawn
  ].join(",");

  // 2) Referencias DOM
  const sliderContainer = document.querySelector(containerSel);
  if (!sliderContainer) return;

  // Busca slides originales SOLO dentro del contenedor detectado
  let originalSlides = sliderContainer.querySelectorAll(slideSel);
  if (originalSlides.length <= 1) return;

  // 3) Clonado de extremos (loop infinito)
  const firstSlideClone = originalSlides[0].cloneNode(true);
  const lastSlideClone  = originalSlides[originalSlides.length - 1].cloneNode(true);
  firstSlideClone.classList.add("clone");
  lastSlideClone.classList.add("clone");
  firstSlideClone.removeAttribute("id");
  lastSlideClone.removeAttribute("id");

  sliderContainer.appendChild(firstSlideClone);
  sliderContainer.insertBefore(lastSlideClone, originalSlides[0]);

  // Releer NodeList (ahora incluye clones)
  const slides = sliderContainer.querySelectorAll(slideSel);

  // 4) Estado
  let index = 1;              // primer slide real
  let isTransitioning = false;

  // Asegura que el wrapper deslice en X (Minimog suele tener display:flex)
  sliderContainer.style.display = sliderContainer.style.display || "flex";
  sliderContainer.style.willChange = "transform";

  // 5) Render inicial
  updateSlider(false);

  function updateSlider(withTransition = true) {
    sliderContainer.style.transition = withTransition
      ? "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
      : "none";

    slides.forEach(s => s.classList.remove("active"));
    slides[index]?.classList.add("active");

    sliderContainer.style.transform = `translateX(-${index * 100}%)`;
  }

  function checkBoundaries() {
    if (index === slides.length - 1) {
      setTimeout(() => { index = 1; updateSlider(false); }, 550);
    }
    if (index === 0) {
      setTimeout(() => { index = slides.length - 2; updateSlider(false); }, 550);
    }
  }

  function nextSlide() {
    if (isTransitioning) return;
    isTransitioning = true;
    index++;
    updateSlider(true);
    checkBoundaries();
    setTimeout(() => (isTransitioning = false), 600);
  }

  function prevSlide() {
    if (isTransitioning) return;
    isTransitioning = true;
    index--;
    updateSlider(true);
    checkBoundaries();
    setTimeout(() => (isTransitioning = false), 600);
  }

  // 6) Botones (si existen en tu variante)
  const prevBtn = document.querySelector(prevBtnSel);
  const nextBtn = document.querySelector(nextBtnSel);
  if (nextBtn) nextBtn.addEventListener("click", nextSlide);
  if (prevBtn) prevBtn.addEventListener("click", prevSlide);

  // 7) Autoplay (lee de data-attrs si existen; si no, usa valores por defecto)
  const autoplayAttr = sliderContainer.getAttribute("data-autoplay");
  const speedAttr    = sliderContainer.getAttribute("data-speed");
  const autoplay = autoplayAttr ? autoplayAttr === "true" : true;   // default true
  const speed    = speedAttr ? parseInt(speedAttr, 10) * 1000 : 5000;

  if (autoplay && slides.length > 2) {
    setInterval(nextSlide, speed);
  }

  // 8) Recalcular en resize
  window.addEventListener("resize", () => updateSlider(false));
});
